
/*Creates a Cookie with the given name, value with expiration as the given days.*/
export function createCookie(name, value, days) {
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    }
    else var expires = "";
    document.cookie = name + "=" + value + expires + "; path=/";
}

/*Creates a Cookie with the given name, value.  Cookie expires at the end of day.*/
export function createCookieToday(name, value) {

    var date = new Date();
    date.setDate(date.getDate() + 1);
    date.setHours(0, 0, 0, 0);
    var expires = "; expires=" + date.toGMTString();
    document.cookie = name + "=" + value + expires + "; path=/";
}

/*Reads a Cookie with the given name and returns the value*/
export function readCookie(name) {

    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        if (c == undefined) return null;
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) {return c.substring(nameEQ.length, c.length);}
    }
    return null;
}

/*Deletes a cookie*/
export function eraseCookie(name) {

    createCookieToday(name, "", -1);
}